import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { useTabs } from "@/context/TabsContext";

export default function TabsBar() {
  const { tabs, activeId, openTab, closeTab, moveTab } = useTabs();
  const navigate = useNavigate();
  const dragIdx = useRef(null);
  const [over, setOver] = useState(null);

  const onDragStart = (i) => (e) => { dragIdx.current = i; e.dataTransfer.effectAllowed = "move"; };
  const onDragOver = (i) => (e) => { e.preventDefault(); setOver(i); };
  const onDrop = (i) => (e) => {
    e.preventDefault();
    if (dragIdx.current != null) moveTab(dragIdx.current, i);
    dragIdx.current = null; setOver(null);
  };

  if (tabs.length === 0) return null;

  return (
    <div className="border-b border-border bg-muted/40" data-testid="tabs-bar">
      <div className="flex items-stretch overflow-x-auto no-scrollbar" role="tablist">
        {tabs.map((t, i) => {
          const Icon = t.icon;
          const active = t.id === activeId;
          const isOver = over === i;
          return (
            <div
              key={t.id}
              draggable
              onDragStart={onDragStart(i)}
              onDragOver={onDragOver(i)}
              onDragLeave={() => setOver(null)}
              onDrop={onDrop(i)}
              role="tab"
              aria-selected={active}
              data-testid={`tab-${t.id.replace(/\//g, "_") || "root"}`}
              className={`group relative flex items-center gap-2 pl-3 pr-2 h-9 min-w-[120px] max-w-[220px] cursor-pointer border-r border-border select-none ${
                active ? "bg-card border-b-2 border-b-primary -mb-px" : "hover:bg-card/60"
              } ${isOver ? "ring-1 ring-primary/40" : ""}`}
              onClick={() => navigate(t.path)}
            >
              <Icon className={`w-3.5 h-3.5 shrink-0 ${active ? "text-primary" : "text-muted-foreground"}`} />
              <span className={`text-xs truncate flex-1 ${active ? "font-bold text-foreground" : "text-foreground/70"}`}>{t.label}</span>
              {tabs.length > 1 && (
                <button
                  type="button"
                  onClick={(e) => { e.stopPropagation(); closeTab(t.id); }}
                  className={`w-5 h-5 rounded-sm flex items-center justify-center transition-opacity ${
                    active ? "opacity-100 hover:bg-muted" : "opacity-0 group-hover:opacity-100 hover:bg-muted"
                  }`}
                  data-testid={`close-tab-${t.id.replace(/\//g, "_") || "root"}`}
                  aria-label={`Cerrar pestaña ${t.label}`}
                >
                  <X className="w-3 h-3" />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
